import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { LoginComponent } from '../login/login.component';
import { timer } from 'rxjs';
import config from 'src/app/config';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-logout-message',
  templateUrl: './logout-message.component.html',
  styleUrls: ['./logout-message.component.scss']
})
export class LogoutMessageComponent extends BaseComponent implements OnInit {
  name: string = "";
  
  @ViewChild('divWithDir') divWithDir: HTMLElement;
  
  constructor(
      public dialogRef: MatDialogRef<LoginComponent>,
      translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    super();
    this.name = data;
    timer(config.logoutMsgClose).subscribe(x => { this.close() })
   }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.divWithDir.dir = this.pageDir;
  }


  close(): void {
    this.dialogRef.close();
    window.location.reload();
  }

}
